// extracted by mini-css-extract-plugin
export default {"wrapper":"ThemeColorPicker_wrapper__aZ6BV","picker":"ThemeColorPicker_picker__I7UTn","thumb":"ThemeColorPicker_thumb__iRd+T","icon":"ThemeColorPicker_icon__uS11D"};